import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Result } from "antd";
import { useSelector } from 'react-redux';
import { VIEW_MODE_MAP } from '@/config/routeConfig';
import { useJumpView } from '@/hooks/use-jump-view';

const InternalNotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const viewMode = useSelector(state => state.App.viewMode);
  const currentViewType = VIEW_MODE_MAP[viewMode];
  
  // 使用 useJumpView hook 进行视图跳转
  const jumpToView = useJumpView();

  const handleGoBack = () => {
    // 优先尝试回退到上一个路由
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      // 如果没有from路径，使用 useJumpView 跳转回当前视图的首页
      jumpToView(viewMode);
    }
  };

  return (
    <div style={{ 
      padding: '50px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh'
    }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            <Button type="primary" onClick={handleGoBack}>
              Back to Home
            </Button>
          </div>
        }
      />
    </div>
  );
};

export default InternalNotFound; 